import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Approach from "@/pages/Approach";
import Journeys from "@/pages/Journeys";
import JourneyPage from "@/pages/JourneyPage";
import ComingSoon from "@/pages/ComingSoon";
import Bespoke from "@/pages/Bespoke";
import People from "@/pages/People";
import StartYourJourney from "@/pages/StartYourJourney";
import NotFound from "@/pages/NotFound";

function useLenis() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
}

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const timer = setTimeout(() => {
        const el = document.getElementById(hash.slice(1));
        if (!el) return;
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -96 });
        else el.scrollIntoView({ block: "start" });
      }, 80);
      return () => clearTimeout(timer);
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return null;
}

function AppShell() {
  useLenis();
  return (
    <div className="flex min-h-screen flex-col bg-canvas text-ink">
      <ScrollManager />
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/our-approach" element={<Approach />} />
          <Route path="/journeys" element={<Journeys />} />
          <Route path="/journeys/coming-soon" element={<ComingSoon />} />
          <Route path="/journeys/bespoke-experiences" element={<Bespoke />} />
          <Route path="/journeys/:slug" element={<JourneyPage />} />
          <Route path="/our-people" element={<People />} />
          <Route path="/start-your-journey" element={<StartYourJourney />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppShell />
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
